import React, { useContext, createContext, useState } from 'react';
import Api from '../services/api';
import { toast } from 'react-hot-toast';
import { useCallback } from 'react';

export const UserManagementContext = createContext({
  count: 0,
  numRow: 0,
  users: [],
  user: {},
  roles: [],
  pages: [],
  listPermissions: [],
  unstructuredPages: [],
  userPermissions: [],
  profiles: [],
  profile: {},

  getProfile: async (id, params) => {},
  getProfiles: async (params) => {},
  getUserPermissions: () => {},
  getUser: () => {},
  getUsers: () => {},
  getRoles: () => {},
  getPages: () => {},
  getUnstructuredPages: () => {},
  getListPermissions: () => {},
  getListPermissionsByUserId: () => {},
});

export default function UserManagementProvider(props) {
  const [users, setUsers] = useState([]);
  const [user, setUser] = useState({});
  const [roles, setRoles] = useState([]);
  const [listPermissions, setListPermissions] = useState([]);
  const [userPermissions, setUserPermissions] = useState([]);
  const [pages, setPages] = useState([]);
  const [unstructuredPages, setUnstructuredPages] = useState([]);

  const [filterUsers, setFilterUsers] = useState([]);
  const [countsummary, setCountSummary] = useState({});

  // for pagination
  const [count, setTotalCount] = useState(0); // use for non table pagination
  const [numRow, setNumRow] = useState(0); // use for table pagination

  const getUserPermissions = async (userId) => {
    await Api.getPermissionsByUserId(userId)
      .then((res) => {
        const { success, data } = res.data;
        if (success) setUserPermissions(data);
      })
      .catch((err) => console.log('err', err));
  };

  const getListPermissions = async () => {
    await Api.getPermissions()
      .then((res) => {
        const data = res.data;
        setListPermissions(data);
      })
      .catch((err) => console.log('err', err));
  };

  const getListPermissionsByUserId = async (code) => {
    await Api.getPermissions()
      .then((res) => {
        const { data } = res.data;

        if (data?.includes(code)) return true;

        return false;
      })
      .catch((err) => {
        console.log('err', err);
        return false;
      });
  };

  const getUnstructuredPages = useCallback(
    async (params) => {
      await Api.getUnstructuredPagesManagement(params)
        .then((res) => {
          const { data } = res;
          // console.log("rdata", res.data);
          setUnstructuredPages(data);
        })
        .catch((err) => console.log('error', err));
    },
    [unstructuredPages]
  );

  const getPages = useCallback(
    async (params) => {
      await Api.getPagesManagement(params)
        .then((res) => {
          const { data } = res.data;
          // console.log("rdata", res.data);
          setPages(data);
        })
        .catch((err) => console.log('error', err));
    },
    [pages]
  );

  const getRoles = useCallback(
    async (params) => {
      await Api.getRoles(params)
        .then((res) => {
          const { data } = res;
          setRoles(data);
        })
        .catch((err) => console.log('error', err));
    },
    [roles]
  );

  const getUsers = useCallback(
    async (params) => {
      await Api.getUsers(params)
        .then((res) => {
          const { data, totalItems, totalCount } = res.data;
          console.log('getuser', data);
          setTotalCount(totalItems);
          setNumRow(totalCount);
          setUsers(data);
        })
        .catch((err) => console.log('error', err));
    },
    [users]
  );

  const getUser = useCallback(
    async (id, params) => {
      await Api.getUser(id, params)
        .then((res) => {
          const { data } = res.data;
          setUser(data);
        })
        .catch((err) => {
          console.log('error get user', err);
        });
    },
    [user]
  );

  return (
    <UserManagementContext.Provider
      value={{
        users,
        roles,
        filterUsers,
        countsummary,
        listPermissions,
        pages,
        unstructuredPages,
        user,
        count,
        numRow,
        userPermissions,

        getUserPermissions,
        getUser,
        getPages,
        getUnstructuredPages,
        getListPermissions,
        getListPermissionsByUserId,
        getRoles,
        getUsers,
      }}
      {...props}
    />
  );
}
